// Setup › Workforce › Claude Code connection (WF-CONTROL): `/c/{slug}/setup/claude-code`. Core
// (listing and revoking stay open; a new connection needs the add-on), managers (the Setup gate).
import { createRoute } from "@tanstack/react-router";
import { ClaudeCodeScreen } from "../features/control/claude-code-screen";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupClaudeCodeRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "claude-code",
  component: function SetupClaudeCodePage() {
    const { api } = setupClaudeCodeRoute.useRouteContext();
    return <ClaudeCodeScreen api={api} company={useCompany()} />;
  },
});
